import React from "react";
import { LibraryModuleForm } from "@/modules/learningCenter/features/ModuleLibrary/components/LibraryModuleForm/LibraryModuleForm";
import { useCreateLibraryModule } from "@/modules/learningCenter/features/ModuleLibrary/hooks/useCreateLibraryModule/useCreateLibraryModule";

const CreateLibraryModule: React.FC = () => {
  const { form, isSubmitting, submitForm, handleCancel } =
    useCreateLibraryModule();

  return (
    <LibraryModuleForm
      form={form}
      isSubmitting={isSubmitting}
      mode="create"
      onCancel={handleCancel}
      onSubmit={submitForm}
    />
  );
};

export default CreateLibraryModule;
